import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "modalContainer" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["innerHTML"]

import { useToastr } from "../ts/toastr";


export default /*@__PURE__*/_defineComponent({
  __name: 'Toastr',
  setup(__props) {

const toastr = useToastr();

function getStyle(type: string) {
    switch (type.toLowerCase()) {
        case "error":
            return "error";
        case "warning":
            return "warning";
        case "information":
            return "information";
        case "success":
            return "success";
    }
}

function close(id: string)
{
    toastr.close(id);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toastr).allToastrs.value, (item) => {
      return (_openBlock(), _createElementBlock("div", _mergeProps({
        key: item.id
      }, { ref_for: true }, { 'data-id': item.id }, {
        onClick: ($event: any) => (close(item.id))
      }), [
        _createElementVNode("div", {
          class: _normalizeClass(["modal", getStyle(item.type)]),
          innerHTML: item.message
        }, null, 10, _hoisted_3)
      ], 16, _hoisted_2))
    }), 128))
  ]))
}
}

})